"use client";

import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

interface Props {
  label: string;
  text: string;
}

export default function PromiseRow({ label, text }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const prefersReducedMotion = useReducedMotion();

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  // Peak white when element is in the center of viewport (~0.5 progress)
  const opacity = useTransform(
    scrollYProgress,
    [0.1, 0.49, 0.51, 0.9],
    [0.25, 1, 1, 0.25],
  );

  return (
    <div ref={ref} className="border-t border-white/10 py-8">
      <motion.div
        style={prefersReducedMotion ? undefined : { opacity }}
        className="grid grid-cols-1 md:grid-cols-[1fr_1fr] gap-4 md:gap-0 items-start"
      >
        <div className="flex md:justify-end md:pr-8">
          <span className="font-heading text-xl sm:text-2xl text-white uppercase">
            {label}
          </span>
        </div>
        <p className="text-xl sm:text-2xl text-white tracking-tight max-w-lg">
          {text}
        </p>
      </motion.div>
    </div>
  );
}
